import { ILSSpinCenter } from ".";

export const GlobalSpin = () => <ILSSpinCenter style={{ fontSize: '20px' }} size="large" tip="ILS Online. Загрузка данных..." />